// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#message[data-v-17c846a0] {\n  background: rgba(10, 165, 233);\n  border: thin solid white;\n  margin-bottom: 10px;\n  color: white;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
